/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EngagementFeedDto } from '../models/EngagementFeedDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SocialInsightsService {
    /**
     * Recently published posts with like/comment counts, across connected platforms
     * @returns EngagementFeedDto
     * @throws ApiError
     */
    public static socialInsightsControllerGetEngagementV1(): CancelablePromise<EngagementFeedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/social-insights/engagement',
        });
    }
}
